module.exports = __webpack_public_path__ + "public/img/project1-2.3d2e9510.jpeg";